<template>
  <div
    class="job-parameters-bar"
    v-if="parameters && Object.keys(parameters).length > 0"
  >
    <div class="params-content">
      <span
        v-for="(value, key) in displayParameters"
        :key="key"
        class="param-tag"
      >
        <span class="param-key">{{ formatLabel(key) }}:</span>
        <span class="param-value">{{ formatValue(value) }}</span>
      </span>
    </div>
    <span
      v-if="status"
      class="status-badge"
      :class="'status-' + status.toLowerCase()"
    >
      {{ status }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'JobParameters',
  props: {
    parameters: {
      type: Object,
      default: () => ({})
    },
    status: {
      type: String,
      default: ''
    }
  },
  computed: {
    displayParameters() {
      if (!this.parameters) return {}
      const result = {}
      Object.keys(this.parameters).forEach(key => {
        const value = this.parameters[key]
        // Skip empty arrays and null/undefined
        if (Array.isArray(value) && value.length === 0) return
        if (value === null || value === undefined) return
        result[key] = value
      })
      return result
    }
  },
  methods: {
    formatLabel(key) {
      // camelCase → Title Case
      return key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, s => s.toUpperCase())
        .trim()
    },
    formatValue(value) {
      if (Array.isArray(value)) {
        return value.join(', ')
      }
      if (typeof value === 'object' && value !== null) {
        return JSON.stringify(value)
      }
      return String(value)
    }
  }
}
</script>

<style scoped lang="scss">
.job-parameters-bar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 2px 0 14px;
  font-size: 13px;

  .params-content {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 18px;
    flex: 1;
    min-width: 0;
  }

  .param-tag {
    min-width: 0;
    color: var(--text2);

    .param-key {
      font-weight: 600;
      color: var(--text2);
      margin-right: 6px;
    }

    .param-value {
      color: var(--text);
      overflow-wrap: anywhere;
    }
  }

  .status-badge {
    flex-shrink: 0;
    font-weight: 700;
    font-size: 11px;
    padding: 3px 9px;
    border-radius: 999px;
    text-transform: uppercase;
    letter-spacing: 0.5px;

    &.status-completed {
      color: var(--green);
      background: var(--green-bg);
    }

    &.status-failed {
      color: var(--red);
      background: var(--red-bg);
    }

    &.status-processing {
      color: var(--amber);
      background: var(--amber-bg);
    }

    &.status-queued,
    &.status-pending {
      color: var(--blue);
      background: var(--blue-bg);
    }
  }
}
</style>
